import React from 'react';

const LogoCarousel = () => {
  // Client logos array - 23 logos total
  // Distributed across 3 rows to avoid ANY duplicates showing at once
  
  // Row 1: 8 logos
  const logosRow1 = [
    { src: 'https://customer-assets.emergentagent.com/job_frog-web-upgrade/artifacts/iwocl4we_Screenshot%202026-03-10%20at%2015.09.59.png', alt: 'Vivo' },
    { src: 'https://customer-assets.emergentagent.com/job_frog-web-upgrade/artifacts/67q1dc09_Screenshot%202026-03-10%20at%2015.10.26.png', alt: 'The British Museum' },
    { src: 'https://customer-assets.emergentagent.com/job_frog-web-upgrade/artifacts/jvc8wjgd_Screenshot%202026-03-10%20at%2015.10.47.png', alt: 'WBAM' },
    { src: 'https://customer-assets.emergentagent.com/job_frog-web-upgrade/artifacts/n49dydy7_Screenshot%202026-03-10%20at%2015.11.04.png', alt: 'London Gatwick' },
    { src: 'https://customer-assets.emergentagent.com/job_frog-web-upgrade/artifacts/eycdbxbv_Screenshot%202026-03-10%20at%2015.11.41.png', alt: 'Conrad Energy' },
    { src: 'https://customer-assets.emergentagent.com/job_frog-web-upgrade/artifacts/09j383n6_Screenshot%202026-03-10%20at%2015.07.13.png', alt: 'Viridis Energy' },
    { src: 'https://customer-assets.emergentagent.com/job_frog-web-upgrade/artifacts/nl5bvlwt_Screenshot%202026-03-10%20at%2015.07.28.png', alt: 'NHS' },
    { src: 'https://customer-assets.emergentagent.com/job_frog-web-upgrade/artifacts/v1x0jrqm_Screenshot%202026-03-10%20at%2015.07.43.png', alt: 'Ministry of Defence' },
  ];

  // Row 2: 8 logos
  const logosRow2 = [
    { src: 'https://customer-assets.emergentagent.com/job_frog-web-upgrade/artifacts/f5cwrt5a_Screenshot%202026-03-10%20at%2015.08.31.png', alt: 'Department for Education' },
    { src: 'https://customer-assets.emergentagent.com/job_frog-web-upgrade/artifacts/b9lqs5bp_Screenshot%202026-03-10%20at%2015.09.12.png', alt: 'Wessex Water VTL Group' },
    { src: 'https://customer-assets.emergentagent.com/job_frog-web-upgrade/artifacts/3iijtud4_Screenshot%202026-03-10%20at%2015.01.51.png', alt: 'Electric Land' },
    { src: 'https://customer-assets.emergentagent.com/job_frog-web-upgrade/artifacts/rfm6872b_Screenshot%202026-03-10%20at%2015.06.14.png', alt: 'Crown Gas & Power' },
    { src: 'https://customer-assets.emergentagent.com/job_frog-web-upgrade/artifacts/cpd3fa8b_Screenshot%202026-03-10%20at%2015.06.28.png', alt: 'Cadent' },
    { src: 'https://customer-assets.emergentagent.com/job_frog-web-upgrade/artifacts/3gleic39_Screenshot%202026-03-10%20at%2015.06.40.png', alt: 'Wales & West Utilities' },
    { src: 'https://customer-assets.emergentagent.com/job_frog-web-upgrade/artifacts/vpzqcw7t_Screenshot%202026-03-10%20at%2015.06.58.png', alt: 'Forsa Energy' },
    { src: 'https://customer-assets.emergentagent.com/job_frog-web-upgrade/artifacts/dywq0pd5_Screenshot%202026-03-10%20at%2015.00.11.png', alt: 'Energy Assets' },
  ];

  // Row 3: 7 logos
  const logosRow3 = [
    { src: 'https://customer-assets.emergentagent.com/job_frog-web-upgrade/artifacts/dyimkdo7_Screenshot%202026-03-10%20at%2015.01.06.png', alt: 'netmore' },
    { src: 'https://customer-assets.emergentagent.com/job_3d30e7b2-d021-46db-b243-02e1cd37828b/artifacts/r92mrvui_Screenshot%202026-03-19%20at%2009.27.52.png', alt: 'Envirco' },
    { src: 'https://customer-assets.emergentagent.com/job_3d30e7b2-d021-46db-b243-02e1cd37828b/artifacts/pgfvx76e_Screenshot%202026-03-10%20at%2015.53.48.png', alt: 'AVK' },
    { src: 'https://customer-assets.emergentagent.com/job_3d30e7b2-d021-46db-b243-02e1cd37828b/artifacts/cov8hhqx_Screenshot%202026-03-10%20at%2015.52.21.png', alt: 'AMP' },
    { src: 'https://customer-assets.emergentagent.com/job_3d30e7b2-d021-46db-b243-02e1cd37828b/artifacts/hsibxy5l_fulcrum%20logo.jpeg', alt: 'Fulcrum' },
    { src: 'https://customer-assets.emergentagent.com/job_3d30e7b2-d021-46db-b243-02e1cd37828b/artifacts/0knghscp_Screenshot%202026-03-10%20at%2015.49.05.png', alt: 'Engie' },
    { src: 'https://customer-assets.emergentagent.com/job_3d30e7b2-d021-46db-b243-02e1cd37828b/artifacts/h3ziof9f_GF%20logo.jpg', alt: 'Green Frog Power client logo' },
  ];

  // Create seamless infinite scroll row
  const Row = ({ logos, speed = 30, direction = 'normal' }) => (
    <div className="relative overflow-hidden py-6">
      <div 
        className="flex gap-16"
        style={{
          animation: `scroll-${direction} ${speed}s linear infinite`,
        }}
      >
        {/* Duplicate logos 4 times for truly seamless infinite scroll */}
        {[...logos, ...logos, ...logos, ...logos].map((logo, index) => (
          <div 
            key={index} 
            className="flex-shrink-0 flex items-center justify-center bg-white rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow"
            style={{ width: '220px', height: '120px' }}
          >
            <img 
              src={logo.src} 
              alt={logo.alt}
              className="max-w-full max-h-full object-contain"
            />
          </div>
        ))}
      </div>
    </div>
  );

  return (
    <div className="py-12 bg-white overflow-hidden border-t border-b border-gray-200">
      <style>{`
        @keyframes scroll-normal {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-25%);
          }
        }
        
        @keyframes scroll-reverse {
          0% {
            transform: translateX(-25%);
          }
          100% {
            transform: translateX(0);
          }
        }
      `}</style>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-8">
        <p className="text-emerald-600 font-medium mb-2 text-sm uppercase tracking-wide">Our Clients</p>
        <h2 className="text-2xl md:text-3xl font-bold text-gray-900">
          Trusted By Leading Organisations
        </h2>
      </div>

      {/* Three rows with DIFFERENT logos in each - no duplicates across rows */}
      <Row logos={logosRow1} speed={50} direction="normal" />
      <Row logos={logosRow2} speed={45} direction="reverse" />
      <Row logos={logosRow3} speed={55} direction="normal" />
    </div>
  );
};

export default LogoCarousel;
